import clsx from 'clsx';
import {
  OFFERTE_STATUSES,
  OFFERTE_STATUS_GROUP_LABELS,
  offerteStatusColor,
  type OfferteStatusGroup,
} from '../../lib/offerte-status';

const GROUP_ORDER: OfferteStatusGroup[] = ['open', 'reactie', 'verloren'];

interface Props {
  value: string;
  busy?: boolean;
  onChange: (status: string) => void;
  className?: string;
}

/**
 * Strakke status-picker voor een offerte (Lead.Status). Toont de gecureerde set
 * uit de SSOT (offerte-status.ts), gegroepeerd. Acceptatie ('Offerte Akkoord')
 * zit hier bewust niet in — dat is een aparte actie met conversie-gevolgen.
 *
 * Een onbekende/legacy status (bv. 'Offerte Akkoord', 'Opdracht') tonen we als
 * losse optie zodat de select 'm kan weergeven zonder de waarde te resetten.
 */
export function OfferteStatusSelect({ value, busy, onChange, className }: Props) {
  const known = OFFERTE_STATUSES.some((s) => s.value === value);

  return (
    <select
      value={value}
      disabled={busy}
      onChange={(e) => {
        if (e.target.value !== value) onChange(e.target.value);
      }}
      title="Offerte-status wijzigen"
      className={clsx(
        'text-xs font-medium rounded px-2 py-0.5 border-0 cursor-pointer',
        'focus:outline-none focus:ring-1 focus:ring-indigo-500 disabled:opacity-50',
        offerteStatusColor(value),
        className
      )}
    >
      {!known && <option value={value}>{value}</option>}
      {GROUP_ORDER.map((group) => (
        <optgroup key={group} label={OFFERTE_STATUS_GROUP_LABELS[group]}>
          {OFFERTE_STATUSES.filter((s) => s.group === group).map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
